import styled, { css } from 'styled-components';

const Count = styled.span`
  margin-left: ${({ theme }) => theme.spacing(2)};
  ${({ isDesktop, theme }) =>
    isDesktop &&
    css`
      color: ${theme.colors.white};
    `}
`;

export default Count;
